import { render, staticRenderFns } from "./ActivationBriefOrderProvider.vue?vue&type=template&id=4faed360&"
import script from "./ActivationBriefOrderProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefOrderProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports